import React from 'react';
import styled from 'styled-components';
import { Button, Tooltip, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  PiSquaresFourBold,
  PiListBulletsBold,
  PiClipboardTextBold,
  PiNotePencilBold,
  PiArrowClockwiseBold,
} from 'react-icons/pi';
import Routes from '~/routes/routes';

const { Text } = Typography;

interface CollectFormHeaderProps {
  viewMode: 'grid' | 'list';
  totalCount: number;
  onViewModeChange: (mode: 'grid' | 'list') => void;
  onRefresh: () => void;
  loading?: boolean;
  isAdmin?: boolean;
}

export const CollectFormHeader: React.FC<CollectFormHeaderProps> = ({
  viewMode,
  totalCount,
  onViewModeChange,
  onRefresh,
  loading,
  isAdmin,
}) => {
  const navigate = useNavigate();

  return (
    <UI_HeaderWrapper>
      <UI_LeftSection>
        <UI_Title>
          <PiClipboardTextBold className="title-icon" />
          <span>{isAdmin ? 'Tất cả biểu mẫu (Admin)' : 'Biểu mẫu của tôi'}</span>
          <UI_BadgeCount>({totalCount} biểu mẫu)</UI_BadgeCount>
        </UI_Title>
      </UI_LeftSection>

      <UI_RightSection>
        <UI_ViewToggle>
          <Tooltip title="Chế độ lưới">
            <UI_IconButton
              type={viewMode === 'grid' ? 'primary' : 'text'}
              icon={<PiSquaresFourBold size={16} />}
              onClick={() => onViewModeChange('grid')}
            />
          </Tooltip>
          <Tooltip title="Chế độ danh sách">
            <UI_IconButton
              type={viewMode === 'list' ? 'primary' : 'text'}
              icon={<PiListBulletsBold size={16} />}
              onClick={() => onViewModeChange('list')}
            />
          </Tooltip>
        </UI_ViewToggle>

        <Tooltip title="Làm mới">
          <Button
            icon={<PiArrowClockwiseBold size={14} />}
            onClick={onRefresh}
            loading={loading}
            style={{ borderRadius: 6 }}
          />
        </Tooltip>

        {isAdmin && (
          <Button
            icon={<PiNotePencilBold size={14} />}
            onClick={() => navigate(Routes.COLLECT_FORM_TEMPLATES)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              borderRadius: '6px',
              fontWeight: 500,
            }}
          >
            Template biểu mẫu
          </Button>
        )}
      </UI_RightSection>
    </UI_HeaderWrapper>
  );
};

const UI_HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  gap: 12px;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const UI_LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const UI_Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;

  .title-icon {
    font-size: 20px;
    color: #2563eb;
  }
`;

const UI_BadgeCount = styled(Text)`
  font-size: 13px;
  font-weight: normal;
  color: #64748b;
`;

const UI_RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 640px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const UI_ViewToggle = styled.div`
  display: flex;
  align-items: center;
  background-color: #f1f5f9;
  border-radius: 6px;
  padding: 2px;
  gap: 2px;
`;

const UI_IconButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px !important;
  border: none !important;

  &:not(.ant-btn-primary) {
    color: #64748b;
    background: transparent;

    &:hover {
      color: #1e293b;
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
`;
